import { useEffect } from 'react';

export const PreloadResources = () => {
  useEffect(() => {
    // Preload critical images
    const criticalImages = [
      // Add your critical above-the-fold images here
    ];

    criticalImages.forEach(src => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = src;
      document.head.appendChild(link);
    });

    // Prefetch next likely pages
    const prefetchPages = ['/product', '/demo', '/contact'];
    
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => {
        prefetchPages.forEach(page => {
          const link = document.createElement('link');
          link.rel = 'prefetch';
          link.href = page;
          document.head.appendChild(link);
        });
      });
    }
  }, []);

  return null;
};
